import React from "react"
import type { RespostasPersonalizadasIzzaModel } from "../models/respostasPersonalizadasIzzaModel"
import { RespostasPersonalizadasIzzaInicial } from "../models/respostasPersonalizadasIzzaModel"
import type { RespostasPersonalizadasIzzaActionModel } from "./respostasPersonalizadasIzzaActions"

interface RespostasPersonalizadasIzzaContextValue {
    dados: RespostasPersonalizadasIzzaModel
    dispatch: React.Dispatch<RespostasPersonalizadasIzzaActionModel>
    erroCarregamento: string | null
    salvar: () => Promise<void>
}

export const RespostasPersonalizadasIzzaContext =
    React.createContext<RespostasPersonalizadasIzzaContextValue>({
        dados: RespostasPersonalizadasIzzaInicial,
        dispatch: () => undefined,
        erroCarregamento: null,
        salvar: async () => undefined,
    })
